import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { CreateExternalLinkDto, ExternalLink } from 'types';

export const createExternalLink = ({
  data,
}: {
  data: CreateExternalLinkDto;
}): Promise<ExternalLink> => {
  return axios.post('/api/external-links', data);
};

type UseCreateExternalLinkOptions = {
  config?: MutationConfig<typeof createExternalLink>;
};

export const useCreateExternalLink = ({
  config,
}: UseCreateExternalLinkOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['externalLinks']);
    },
    ...config,
    mutationFn: createExternalLink,
  });
};
